import React from 'react';
import { Globe } from 'lucide-react';
import { 
  DropdownMenu, 
  DropdownMenuContent, 
  DropdownMenuItem, 
  DropdownMenuTrigger 
} from './ui/dropdown-menu';
import { useLanguage } from '../context/LanguageContext';

export default function LanguageSelector({ variant = 'default' }) {
  const { language, setLanguage } = useLanguage();

  const getFlag = (lang) => {
    switch (lang) {
      case 'fr': return '🇫🇷';
      case 'en': return '🇬🇧';
      case 'pt': return '🇵🇹';
      default: return '🌐';
    }
  };

  const languages = [
    { code: 'fr', label: 'Français' },
    { code: 'en', label: 'English' },
    { code: 'pt', label: 'Português' },
  ];

  if (variant === 'compact') {
    return (
      <DropdownMenu>
        <DropdownMenuTrigger asChild>
          <button
            className="flex items-center gap-1.5 text-sm font-medium text-muted-foreground hover:text-foreground transition-colors px-2 py-1 rounded-md hover:bg-muted"
            data-testid="language-selector"
          >
            <Globe className="w-4 h-4" />
            <span>{getFlag(language)}</span>
          </button>
        </DropdownMenuTrigger>
        <DropdownMenuContent align="end">
          {languages.map((lang) => (
            <DropdownMenuItem 
              key={lang.code}
              onClick={() => setLanguage(lang.code)} 
              className={language === lang.code ? 'bg-muted' : ''}
            >
              {getFlag(lang.code)} {lang.label}
            </DropdownMenuItem>
          ))}
        </DropdownMenuContent>
      </DropdownMenu>
    );
  }

  // Default variant with full display
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <button
          className="flex items-center gap-2 text-sm font-medium px-3 py-2 rounded-lg border hover:bg-muted transition-colors"
          data-testid="language-selector"
        >
          <Globe className="w-4 h-4 text-muted-foreground" />
          <span>{getFlag(language)}</span>
          <span className="hidden sm:inline">
            {languages.find(l => l.code === language)?.label}
          </span>
        </button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="w-40">
        {languages.map((lang) => (
          <DropdownMenuItem 
            key={lang.code}
            onClick={() => setLanguage(lang.code)} 
            className={`flex items-center gap-2 ${language === lang.code ? 'bg-muted' : ''}`}
          >
            <span>{getFlag(lang.code)}</span>
            <span>{lang.label}</span>
            {language === lang.code && (
              <span className="ml-auto text-primary">✓</span>
            )}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
